export default {

  data: {

    /* 
      - This is used for registering GCM/APN push notifications through our server.
      - The pushRegistration token has 2 pieces that are race-cased. When each one is set, we'll call the initPush function and let it reject us if we don't have enough information. Between the 2 tries of us calling this function, the first will always be rejected, but provide the inforamtion necessary for the other's try to be accepted.
    */
    pushRegistration: {
      platformId: false,
      profileLoaded: false,
      platformId: window.cordova ? (window.cordova.platformId === 'android' ? 'gcm' : 'apn') : false
    }
    
  },

  methods: {

    // This function will initialize the Push token to the Vilio server
    initPush (params) {

      // Set whatever was passed in
      for (var key in params) {
        this.pushRegistration[key] = params[key];
      }
      
      // See if we can register push now
      if (this.pushRegistration.platformId && this.pushRegistration.registrationId && this.pushRegistration.profileLoaded) {
        
        // Check if the push token is different
        var pushToken = window.localStorage.getItem('pushToken') || false;

        if (!pushToken || pushToken && pushToken.token !== this.registrationId) {

          this.$store.dispatch('registerPush', {
            type: this.pushRegistration.platformId,
            token: this.pushRegistration.registrationId
          })
          .then(data => {
            console.log('Push Token Registered');
            window.localStorage.setItem('pushToken', this.pushRegistration.registrationId);
          })
          .catch(e => {
            console.log(e);
          });

        }
      }
    },

    // Unregister Push
    unregisterPush (token) {
      
      return this.$store.dispatch('unregisterPush', {
        type: this.pushRegistration.platformId,
        token: token
      })
      .then(data => {
        console.log('Push Token Unregistered');
        window.localStorage.removeItem('pushToken');
      })
      .catch(e => {
        console.log(e);
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/AppData/handlePushToken.js